export default __webpack_public_path__ + "static/media/astronaut.95c8b098.png";